// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1WE97","content":"LoadingAlert_content__1US1W"};